/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Banner from "../../../components/common/form/Banner";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useDispatch, useSelector } from "react-redux";
import { NotificationIcon } from "../../../components/common/svg/AllSvg";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Error from "../../../components/common/form/Error";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import { Link } from "react-router-dom";
import { dataActions } from "../../../shared/store/data-Slice";

const Notice = () => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const [select, setSelect] = useState<any>("All")
  const category: any[] = ["All", "Notification", "Updates", "Alerts"]
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true)
  const [isError, setIsError] = useState<boolean>(false)
  const loaderData: any[] = [1, 2, 3, 4, 5]
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  useSitemap();

  const getNotice = async () => {
    try {
      setLoading(true)
      setIsError(false)
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.notice}`);

      if (res && res.status === 200) {
        setData(res?.data)
        setLoading(false)
      }
    } catch (error) {
      setIsError(true)
      setLoading(false)
      console.error("error while fetching notice", error);
    }
  }

  useEffect(() => {
    !!lang && getNotice();
  }, [lang])

  const handleLink = (item: any) => {
    dispatch(dataActions.setWebOpen(true));
    dispatch(dataActions.setLink(item));
  }

  return (
    <>
      <Canonical />
      <Helmet>
        <title>{t("seo_friendly.notice.title")}</title>
        <meta name="description" content={t("seo_friendly.notice.desc")} />
      </Helmet>
      <div className="bg-white dark:bg-bgDarkDull">
        <Banner title={t("passenger.home.banner.notification")} />
        <div className="container flex items-center justify-center pt-[40px] pb-[95px]" id="home">
          <div className="w-[1085px] flex flex-col gap-[20px]">
            {/* <div className="flex items-center justify-start w-full flex-wrap gap-[10px]">
            {Array.isArray(category) && category?.map((item: any, index: number) => (
              <button key={index} className={`${select === item ? "bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} text-base font-semibold flex items-center justify-center px-[20px] h-[35px] rounded-[20px] border border-[#D6D6D6] dark:border-[#454545]`} onClick={() => setSelect(item)}>{item}</button>
            ))}
          </div> */}
            {loading ?
              <div className="w-full border border-gray-200 dark:border-gray-700 animate-pulse">
                {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                  <div key={index} className={`${(index + 1 === loaderData?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full p-[15px] sm:px-[30px] xlx:px-[38px] sm:py-[20px] xlx:py-[24px] gap-[20px] xlx:gap-[30px] flex items-center`}>
                    <div className="min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    <div className="flex flex-col gap-[5px] w-full">
                      <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                      <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    </div>
                  </div>
                ))}
              </div>
              :
              <>
                {isError ? <Error />
                  : <div className="w-full border dark:border-[#454545] border-[#E7E8EC]">
                    {Array.isArray(data) && data.map((item: any, index: number) => (
                      <div className={`${(index + 1 === data?.length) ? "" : "border-b dark:border-[#454545] border-[#E7E8EC]"} w-full p-[15px] sm:px-[30px] xlx:px-[38px] sm:py-[20px] xlx:py-[24px] gap-[20px] xlx:gap-[30px] flex items-center`}>
                        <div className="min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] flex items-center justify-center rounded-full bg-[#B6C4F4] dark:bg-[#B6C4F4] dark:bg-opacity-[0.9] bg-opacity-[0.5]">
                          <NotificationIcon />
                        </div>

                        <div className="flex flex-col gap-[5px]">
                          <h5 className="text-primary font-bold uppercase">{moment(item?.date).format('MMM DD, YYYY')}</h5>
                          {(!!item?.link_to_outside_url || !!item?.link_to_file?.file || !!item?.link_to_internal_page) ?
                            <Link to={!!item?.link_to_outside_url ? item?.link_to_outside_url : !!item?.link_to_internal_page ? item?.link_to_internal_page : item?.link_to_file?.file} target={(!!item?.link_to_outside_url || !!item?.link_to_file?.file) ? "_blank" : "_self"} className="text-blackDull dark:text-textBlackDull font-medium text-base *:text-blackDull *:dark:text-textBlackDull *:font-medium *:text-base focus:*:underline hover:*:underline focus:underline hover:underline" dangerouslySetInnerHTML={{ __html: item?.html_message }} onClick={(e: any) => { !!item?.link_to_outside_url && e.preventDefault(); !!item?.link_to_outside_url && handleLink(item?.link_to_outside_url); }} />
                            :
                            <h5 className="text-blackDull dark:text-textBlackDull font-medium text-base *:text-blackDull *:dark:text-textBlackDull *:font-medium *:text-base" dangerouslySetInnerHTML={{ __html: item?.html_message }} />
                          }
                        </div>
                      </div>
                    ))}
                  </div>}
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Notice;